import { Auth0Provider } from "@auth0/auth0-react";
import { useIsMobile } from "hooks/useIsMobile";

const Auth0ProviderWithHistory = ({ children }) => {

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUDIENCE;

  useIsMobile();

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      audience={audience}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience,
        scope: "openid profile email create:user_tickets update:users update:users_app_metadata update:current_user_metadata"
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
